import React, { useCallback, useEffect, useState, useContext } from "react";
import { Grid } from "@material-ui/core";
import { useRestaurantEditStyles } from "../../Util/CSS/RestaurantEdit/RestaurantEdit";
import { withRouter } from "react-router-dom";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import LoadingScreen from "../../Shared/LoadingScreen";
import RestaurantDetails from "./RestaurantDetails/RestaurantDetails";

const RestaurantEdit = () => {
  const classes = useRestaurantEditStyles();
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  useEffect(() => {
    return () => {
      setLoading(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, []);

  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <Grid container direction="row">
          <Grid item xs={12} className={classes.mb30}>
            <RestaurantDetails />
          </Grid>
        </Grid>
      )}
      {snackbarOpen && (
        <OpenSnackbar
          message={snackbarDetails.message}
          type={snackbarDetails.type}
          open={snackbarOpen}
          setOpen={setSnackbarOpen}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </>
  );
};

export default withRouter(RestaurantEdit);
